import React, { useState, Component } from 'react';
import { Hero } from '../components/Hero';
import { AboutSection } from '../components/AboutSection';
import { ClassesSection } from '../components/ClassesSection';
import { BookingSection } from '../components/BookingSection';
import { GallerySection } from '../components/GallerySection';
import { CoursesSection } from '../components/CoursesSection';
import { ContactSection } from '../components/ContactSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { Toast } from '../components/ui/Toast';
import { Leaf, Activity, MessageCircle, Camera, Mail, Menu, X, ChevronDown } from 'lucide-react';
type TabType = 'sobre' | 'clases' | 'testimonios' | 'galeria' | 'contacto';
export function LandingPage() {
  const [activeMainTab, setActiveMainTab] = useState<TabType>('sobre');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeBookingTab, setActiveBookingTab] = useState<'presencial' | 'virtual'>('presencial');
  const [toast, setToast] = useState({
    visible: false,
    message: '',
    type: 'success' as 'success' | 'warning'
  });
  const showToast = (message: string, type: 'success' | 'warning') => {
    setToast({
      visible: true,
      message,
      type
    });
  };
  const handleBookClass = (type: 'presencial' | 'virtual') => {
    setActiveBookingTab(type);
    setActiveMainTab('clases');
  };
  const handleTabClick = (tabId: TabType) => {
    if (tabId === 'sobre') {
      const aboutSection = document.getElementById('sobre-nosotros');
      if (aboutSection) {
        aboutSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else if (tabId === 'clases') {
      const clasesSection = document.getElementById('clases');
      if (clasesSection) {
        clasesSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    setActiveMainTab(tabId);
  };
  const tabs = [{
    id: 'sobre' as TabType,
    label: 'Sobre Nosotros',
    icon: Leaf
  }, {
    id: 'clases' as TabType,
    label: 'Clases',
    icon: Activity
  }, {
    id: 'testimonios' as TabType,
    label: 'Testimonios',
    icon: MessageCircle
  }, {
    id: 'galeria' as TabType,
    label: 'Galería',
    icon: Camera
  }, {
    id: 'contacto' as TabType,
    label: 'Contacto',
    icon: Mail
  }];
  return <div className="min-h-screen" data-id="element-1172">
      {/* Fixed Navigation Bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-cream/95 backdrop-blur-xl border-b border-earth/10 shadow-sm" data-id="element-1173">
        <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-1174">
          <div className="flex items-center justify-between gap-6 py-3" data-id="element-1175">
            <img src="https://cdn.magicpatterns.com/uploads/orGsLQ6JjLrrbBiAdT5pof/vimutti_yoga_logo_transparent.png" alt="Vimutti Yoga" className="h-16 md:h-32 flex-shrink-0" data-id="element-1176" />

            {/* Desktop Tabs */}
            <div className="hidden md:flex overflow-x-auto hide-scrollbar w-auto" data-id="element-1177">
              {tabs.map(tab => {
              const IconComponent = tab.icon;
              return <button key={tab.id} onClick={() => handleTabClick(tab.id)} className={`flex items-center gap-2 px-4 py-3 font-medium text-sm whitespace-nowrap border-b-2 transition-all ${activeMainTab === tab.id ? 'border-sage text-sage' : 'border-transparent text-stone hover:text-earth hover:bg-sand/50'}`} data-id="element-1178">
                    <IconComponent size={18} data-id="element-1179" />
                    {tab.label}
                  </button>;
            })}
            </div>

            {/* Mobile Menu Toggle */}
            <div className="md:hidden relative" data-id="element-1180">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-earth rounded-md hover:bg-sand transition-colors" aria-label="Menú" data-id="element-1181">
                {isMobileMenuOpen ? <X size={24} data-id="element-1182" /> : <Menu size={24} data-id="element-1183" />}
              </button>

              {/* Mobile Dropdown */}
              {isMobileMenuOpen && <div className="absolute top-full right-0 mt-2 w-48 bg-cream border border-earth/10 rounded-xl shadow-lg overflow-hidden animate-fade-slide-up" data-id="element-1184">
                  {tabs.map(tab => {
                const IconComponent = tab.icon;
                return <button key={tab.id} onClick={() => {
                  handleTabClick(tab.id);
                  setIsMobileMenuOpen(false);
                }} className={`flex items-center gap-3 w-full px-4 py-3 text-sm transition-colors ${activeMainTab === tab.id ? 'bg-sage/10 text-sage font-semibold' : 'text-stone hover:bg-sand/50 hover:text-earth'}`} data-id="element-1185">
                        <IconComponent size={16} data-id="element-1186" />
                        {tab.label}
                      </button>;
              })}
                </div>}
            </div>
          </div>
        </div>
      </nav>

      <Hero onExploreClick={() => setActiveMainTab('sobre')} onBookClick={() => setActiveMainTab('clases')} onClassesClick={() => setActiveMainTab('clases')} data-id="element-1187" />

      {/* Tab Content */}
      <main data-id="element-1188">
        {activeMainTab === 'sobre' && <div className="animate-fade-slide-up" data-id="element-1189">
            <AboutSection data-id="element-1190" />
          </div>}

        {activeMainTab === 'clases' && <div className="animate-fade-slide-up" data-id="element-1191">
            <ClassesSection onBookClass={handleBookClass} data-id="element-1192" />
            <BookingSection activeTab={activeBookingTab} setActiveTab={setActiveBookingTab} showToast={showToast} data-id="element-1193" />
          </div>}

        {activeMainTab === 'testimonios' && <div className="animate-fade-slide-up" data-id="element-1194">
            <TestimonialsSection data-id="element-1195" />
          </div>}

        {activeMainTab === 'faq' && <div className="animate-fade-slide-up" data-id="element-1196">
            <FAQSection data-id="element-1197" />
          </div>}

        {activeMainTab === 'galeria' && <div className="animate-fade-slide-up" data-id="element-1198">
            <GallerySection data-id="element-1199" />
          </div>}

        {activeMainTab === 'cursos' && <div className="animate-fade-slide-up" data-id="element-1200">
            <CoursesSection data-id="element-1201" />
          </div>}

        {activeMainTab === 'contacto' && <div className="animate-fade-slide-up" data-id="element-1202">
            <ContactSection showToast={showToast} data-id="element-1203" />
          </div>}
      </main>

      <Footer data-id="element-1204" />

      <Toast isVisible={toast.visible} message={toast.message} type={toast.type} onClose={() => setToast(prev => ({
      ...prev,
      visible: false
    }))} data-id="element-1205" />
    </div>;
}